<template>
  <div
    v-if="requirement"
    class="offer-requirements"
    data-qa="offer-requirement-item"
    @click.stop="changeShowModal">
    <template v-if="requirement.status === 'COMPLETED'">
      <span :class="labelClass">{{ $t('AIRequirements.Requirements') }}:</span>
      <sTooltip
        trigger="hover">
        <span
          class="offer-requirements_rate"
          :style="`--backgroundColor: ${color}; color: black;`">{{ requirement.complianceRate }}%</span>
        <OfferRequirementIndicators
          slot="content"
          class="flex gap-5"
          :requirements="requirement.requirements"/>
      </sTooltip>
    </template>
    <template v-else-if="requirement.status === 'IN_PROGRESS'">
      <sIcon
        class="my-5 mx-auto"
        color="var(--secondary__green_not_active)"
        size="14"
        spin
        type="loading"/>
      <div :data-qa="`offer-requirement-item_${requirement.status}`">
        {{ $t(`AIRequirements.Statuses.${requirement.status}`) }}
      </div>
    </template>
  </div>
</template>
<script>
import OfferRequirementIndicators from 'components/tenders/tender page/tender tabs/OfferRequirementIndicators.vue'

export default {
  name: 'OfferRequirements',

  methods: {
    changeShowModal() {
      if (this.requirement.status !== 'COMPLETED') {
        return
      }
      this.$emit('showModalInfo')
    }
  },
  computed: {
    color() {
      if (!this.requirement) {
        return 'var(--color-secondary)'
      }
      if (this.requirement.isBest) {
        return 'var(--v-secondary__green_approved-base)'
      }
      if (this.requirement.complianceRate <= 20) {
        return 'var(--color-error)'
      } else {
        return 'var(--color-warning)'
      }
    },
  },
  components: {
    OfferRequirementIndicators,
  },
  props: {
    requirement: {
      type: Object,
    },
    labelClass: {
      type: String,
    }
  },
}
</script>
<style scoped lang="scss">
.offer-requirements {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 12px;
  &_rate {
    font-weight: 500;
    background-color: var(--backgroundColor);
    padding: 1px 6px;
    border-radius: 4px;
  }
}
</style>